import { normalizePhoneNumber } from '@/shared/lib/core/common';

export function userActualPhone(
  b24VerifiedPhone?: string,
  bitrixPhone?: string,
  firstSVCPhone?: string,
) {
  b24VerifiedPhone &&= normalizePhoneNumber(b24VerifiedPhone);
  bitrixPhone &&= normalizePhoneNumber(bitrixPhone);
  firstSVCPhone &&= normalizePhoneNumber(firstSVCPhone);
  let isVerifiedB24 = false;
  let isVerifiedByClient = false;
  let isDifferentInSources = false;
  let actualPhone = null;
  let isBitrixAndB24VerifiedDifferent = false;

  if (b24VerifiedPhone) {
    isVerifiedB24 = true;
  }

  if (bitrixPhone) {
    isVerifiedByClient = true;
    actualPhone = bitrixPhone;

    if (b24VerifiedPhone) {
      isDifferentInSources = bitrixPhone !== b24VerifiedPhone;
      isBitrixAndB24VerifiedDifferent = bitrixPhone !== b24VerifiedPhone;
    } else {
      isDifferentInSources = true;
    }
  }

  return {
    bitrixPhone,
    isVerifiedB24,
    isVerifiedByClient,
    isDifferentInSources,
    isBitrixAndB24VerifiedDifferent,
    actualPhone,
    existedPhone: actualPhone || b24VerifiedPhone || firstSVCPhone,
    firstSVCPhone,
    b24VerifiedPhone,
  };
}
